module.exports = __webpack_public_path__ + "static/media/grey-flag.bd89099f.svg";